var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCheckDecision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8,38.9H13.2c-1.3,0-2.4-1.1-2.4-2.4V12.9c0-1.3,1.1-2.4,2.4-2.4h23.6c1.3,0,2.4,1.1,2.4,2.4v23.6c0,1.3-1.1,2.4-2.4,2.4ZM13.2,11.9c-.5,0-.9.4-.9.9v23.6c0,.5.4.9.9.9h23.6c.5,0,.9-.4.9-.9V12.9c0-.5-.4-.9-.9-.9H13.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21,11.2V4h1.5v7.2h-1.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,11.2V4h1.5v7.2h-1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21,45.4v-7.2h1.5v7.2h-1.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,45.4v-7.2h1.5v7.2h-1.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2,28.6h-7.2v-1.5h7.2v1.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2,22.2h-7.2v-1.5h7.2v1.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45,28.6h-7.2v-1.5h7.2v1.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45,22.2h-7.2v-1.5h7.2v1.5Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "32.2 19 22.9 28.4 19.3 24.9 18.4 25.8 22.9 30.3 33.1 19.9 32.2 19"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckDecision);
export default __webpack_public_path__ + "static/media/icon-check-decision.7c546edbc1379f6ca99b1421fbdb61ad.svg";
export { ForwardRef as ReactComponent };